<template>
  <div>
    <vxe-grid
      ref="skuTable"
      auto-resize
      highlight-hover-row
      resizable
      show-footer
      size="mini"
      row-id="amzSkuCode"
      cell-class-name="align-top"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="700"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :edit-rules="editRules"
      :footer-method="() => footerData"
      @edit-closed="editClosed"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="row.defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[
            row.defaultImageUrl || '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px; "
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" style="width: 60px;" />
          </div>
        </el-image>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:displayName="{ row }">
        <div class="m-0">
          <div>{{ row.goodsName }}</div>
          <div>{{ row.goodsNameEn }}</div>
          <div>
            <span>SIZE:</span><span>{{ row.goodsSize }}</span>
          </div>
          <div>
            <span>COLOR:</span
            ><span>{{ row.goodsColor }}{{ row.goodsColorEn }}</span>
          </div>
        </div>
      </template>
      <template v-slot:displayNo="{ row }">
        <div class="m-0">
          <div>NC:{{ row.ncNo }}</div>
          <div>SKU:{{ row.amzSkuNo }}</div>
          <div>SPU:{{ row.amzSpuNo }}</div>
          <!-- <div>
            {{ $l('table_label_inCtnQty') || '装箱入数' }} :{{ row.inCtnQty }}
          </div> -->
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import {
  format,
  add,
  multiply,
  divide,
  divideDown,
} from '@/libs/util.number.js'
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    loading: { type: Boolean, default: false },
    tablePage: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
    prohibit: { type: Boolean, default: false },
    designDisabled: { type: Boolean, default: false },
    operateDisabled: { type: Boolean, default: false },
    disabledPrint: { typ: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (number) => format(number),
      tableColumns: tableColumns(this),
      editRules: {
        // inCtnQty: [
        //   {
        //     type: 'number',
        //     required: true,
        //     message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
        //   },
        //   {
        //     validator: ({ cellValue }) => {
        //       if (!cellValue) {
        //         return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
        //       }
        //     },
        //   },
        // ],
        qty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue, row }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }

              const { qty, inCtnQty } = row
              const ctnQty = divideDown(qty, inCtnQty, 0)
              const _qty = multiply(ctnQty, inCtnQty)

              if (qty !== _qty) {
                return new Error('需求数量不满整箱')
              }
            },
          },
        ],
      },
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          const val = totalColumnValues[t.field]
          return val >= 0 ? format(val) : ''
        })
      result[2] = this.$l('table_label_total') || '合计'
      return [result]
    },
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { amzFirstDemandDetailCode = '' } = data

      switch (menuType) {
        case 'detail':
        case 'planningEditor':
        case 'operationsEditor':
          this.$emit('openEditSkuDialog', {
            pageType: menuType,
            code: amzFirstDemandDetailCode,
          })
          break
        case 'delete':
          this.remove(data)
          break
        // case 'submit':
        //   this.$emit('submit', [amzFirstDemandCode])
        //   break
        // case 'review':
        //   this.review(data)
        //   break
        case 'reject':
          this.reject(data)
          break
      }
    },
    remove({ amzFirstDemandDetailCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .ecomAmzFirstDemandDetailDelApi({ amzFirstDemandDetailCode })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
    async editClosed({ row }) {
      const { inCtnQty, qty } = row
      const ctnQty = divide(qty, inCtnQty)
      row.ctnQty = ctnQty

      const result = await this.$refs.skuTable.validate(row)

      if (!result) {
        this.loadingOpen()
        this.$api
          .ecomAmzFirstDemandDetailEditSaveApi({
            ...row,
          })
          .then((res) => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || res.msg,
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      } else {
        await this.$refs.skuTable.blur()
      }
    },
    async getTableData() {
      const { tableData } = await this.$refs.skuTable.getTableData()
      return tableData
    },
    async validate() {
      const tableData = await this.getTableData()
      if (!tableData || !tableData.length) {
        this.$message.error('请添加产品明细！')
        return false
      }
      const result = await this.$refs.skuTable.validate(true)
      return !result
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
}
</style>
